import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=1f610910&"
import script from "./Examination.vue?vue&type=script&lang=ts&"
export * from "./Examination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f610910')) {
      api.createRecord('1f610910', component.options)
    } else {
      api.reload('1f610910', component.options)
    }
    module.hot.accept("./Examination.vue?vue&type=template&id=1f610910&", function () {
      api.rerender('1f610910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/Examination.vue"
export default component.exports